module.exports = __webpack_public_path__ + "img/2.10d34df9.png";